module.exports = __webpack_public_path__ + "img/user-name.4c75946f.svg";